"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var TextField_1 = require("office-ui-fabric-react/lib/TextField");
var Rating_1 = require("office-ui-fabric-react/lib/Rating");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var ListingReviewForm_styles_1 = require("./ListingReviewForm.styles");
var ListingReviewForm_classNames_1 = require("./ListingReviewForm.classNames");
var ListingReviewEditor = /** @class */ (function (_super) {
    __extends(ListingReviewEditor, _super);
    function ListingReviewEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onRatingChanged = function (rating) {
            _this.props.review.setRate(rating);
        };
        _this._onCommentsChanged = function (text) {
            _this.props.review.setText(text);
        };
        return _this;
    }
    ListingReviewEditor.prototype.render = function () {
        return (React.createElement("div", { className: this.props.className },
            React.createElement("div", { className: "rating" },
                React.createElement(Rating_1.Rating, { min: 1, max: 5, onChanged: this._onRatingChanged, rating: this.props.review.rate || null, disabled: this.props.review.sync.syncing })),
            React.createElement("div", { className: "review" },
                React.createElement(TextField_1.TextField, { placeholder: "Tell us what you think", multiline: true, resizable: false, onChanged: this._onCommentsChanged, disabled: this.props.review.sync.syncing }))));
    };
    ListingReviewEditor = __decorate([
        mobx_react_1.observer
    ], ListingReviewEditor);
    return ListingReviewEditor;
}(React.Component));
exports.ListingReviewEditor = ListingReviewEditor;
var ListingReviewActions = /** @class */ (function (_super) {
    __extends(ListingReviewActions, _super);
    function ListingReviewActions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onClickCancel = function () {
            if (_this.props.onCancel) {
                _this.props.onCancel();
            }
        };
        _this._onClickSave = function () {
            _this.props.review.save().then(function () {
                if (!_this.props.review.sync.error && _this.props.onAfterSave) {
                    _this.props.onAfterSave(_this.props.review);
                }
            });
        };
        return _this;
    }
    ListingReviewActions.prototype.render = function () {
        var savedDisabled = this.props.review.sync.syncing || this.props.review.rate === null || this.props.review.rate === undefined;
        return (React.createElement("div", { className: this.props.className },
            React.createElement(Button_1.DefaultButton, { className: "listing-review-action", onClick: this._onClickCancel, disabled: this.props.review.sync.syncing }, "Cancel"),
            React.createElement(Button_1.PrimaryButton, { className: "listing-review-action", iconProps: { iconName: "Save" }, onClick: this._onClickSave, disabled: savedDisabled }, "Save")));
    };
    ListingReviewActions = __decorate([
        mobx_react_1.observer
    ], ListingReviewActions);
    return ListingReviewActions;
}(React.Component));
var ListingReviewForm = /** @class */ (function (_super) {
    __extends(ListingReviewForm, _super);
    function ListingReviewForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListingReviewForm.prototype.render = function () {
        var classNames = ListingReviewForm_classNames_1.getClassNames(ListingReviewForm_styles_1.getStyles(undefined, this.props.styles), this.props.className);
        return (React.createElement("div", { className: classNames.root },
            React.createElement(ListingReviewEditor, __assign({}, this.props, { className: classNames.editor })),
            React.createElement(ListingReviewActions, __assign({}, this.props, { className: classNames.actions }))));
    };
    return ListingReviewForm;
}(React.Component));
exports.ListingReviewForm = ListingReviewForm;
